import { useDeviceData } from "@/services/api/hooks/use-device-data";
import { setDeviceContext } from "@/utils/sentry";
import { useEffect } from "react";

/**
 * Renders nothing. Tags the Sentry scope with kiosk device/course identity
 * once `useDeviceData` resolves, so every subsequent error, metric gauge,
 * heartbeat, and replay is filterable by device in Sentry. Must render
 * inside ApiProvider (useDeviceData needs the urql context).
 */
export const SentryDeviceContext = () => {
  const { data } = useDeviceData();
  const appData = data?.applicationData;
  const device =
    appData?.__typename === "OnCourseKioskDeviceData" ? appData.device : null;

  useEffect(() => {
    if (!device) {
      return;
    }
    setDeviceContext({
      id: device.id,
      name: device.name,
      course: device.course,
      hole: device.hole ?? null,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [device?.id]);

  return null;
};
